import { Inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { OKTA_AUTH } from '@okta/okta-angular';
import OktaAuth from '@okta/okta-auth-js';
import { RoutesKeys } from 'src/app/utils/routes';
import { DialogService } from '../dialog/dialog.service';
import { TranslationService } from '../translation/translation.service';
import { LocalStorageKeys } from 'src/app/shared/models/constants/storage.keys';

@Injectable({
  providedIn: 'root',
})
/**
 * Service used to perform authentication tasks
 */
export class AuthenticationService {
  _isLoggingOut = false;
  dialogLabels = {
    sessionExpired: 'session-expired',
    loggingOut: 'redirect-login',
  };

  /**
   * @constructor
   */
  constructor(
    @Inject(OKTA_AUTH) private readonly oktaAuth: OktaAuth,
    @Inject('Window') private readonly window: Window,
    private readonly router: Router,
    private dialogService: DialogService,
    private translationService: TranslationService
  ) {
    translationService.translateObject(this.dialogLabels);

    this.oktaAuth.tokenManager.on('expired', () => {
      this.dialogService.openDialog(
        {
          title: this.dialogLabels.sessionExpired,
          content: this.dialogLabels.loggingOut,
        },
        () => {}, // NOSONAR
        () => {
          this.logout();
        }
      );
    });
  }

  /**
   * If log out flow has been initiated
   */
  get isLoggingOut() {
    return this._isLoggingOut;
  }

  /**
   * Clear this app's okta cache and redirect to epson home page
   */
  logout() {
    if (this.isLoggingOut) {
      return;
    }
    this._isLoggingOut = true;
    this.router.navigate([RoutesKeys.LOGOUT], { replaceUrl: true });
    this.oktaAuth.tokenManager.clear();
    localStorage.removeItem(LocalStorageKeys.GLOBAL_JUST_LOGGED);
    this.window.location.replace('https://epson.com');
  }
}
